import { People } from "@dreamhub/designsystem/icons";
import PageLayout from "@/pages/settings/components/PageLayout";
import { FieldManagementTab } from "@/pages/settings/components/peopleSettings/FieldManagementTab";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { PeopleSettingsTabs } from "@/pages/settings/types";
import { useSearchParams } from "react-router-dom";

const TRANSLATION_KEY = "settings.people";
const TRANSLATION_KEY_TABS = "settings.people.tabs";

export const PeopleSettings = () => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();

  const [tabValue, setTabValue] = useState<PeopleSettingsTabs>(() => {
    const tabParam = searchParams.get("tab");
    return Object.values(PeopleSettingsTabs).includes(
      tabParam as PeopleSettingsTabs
    )
      ? (tabParam as PeopleSettingsTabs)
      : PeopleSettingsTabs.FIELD_MANAGEMENT;
  });

  useEffect(() => {
    setSearchParams((prev) => {
      const params = new URLSearchParams(prev);
      params.set("tab", tabValue);
      return params;
    });
  }, [tabValue, setSearchParams]);

  const getTabOptions = () => {
    const options: Record<string, string> = {};
    Object.values(PeopleSettingsTabs).forEach((tab) => {
      options[tab] = t(`${TRANSLATION_KEY_TABS}.${tab}`);
    });

    return options;
  };

  const onTabChange = (newTabValue: string) => {
    setTabValue(newTabValue as PeopleSettingsTabs);
  };

  const renderTabContent = () => {
    switch (tabValue) {
      case PeopleSettingsTabs.FIELD_MANAGEMENT:
        return <FieldManagementTab />;
      default:
        return <FieldManagementTab />;
    }
  };

  return (
    <PageLayout
      data-test="settings-people-page"
      title={t(`${TRANSLATION_KEY}.title`)}
      logoIcon={<People />}
      tabs={{
        options: getTabOptions(),
        defaultValue: tabValue,
        valueSelected: onTabChange
      }}
    >
      {renderTabContent()}
    </PageLayout>
  );
};
